import { ThemeEvents } from '@theme/events';

/**
 * A custom element that renders the case/pack pricing label on the PDP.
 * It listens for variant update events and swaps its contents with the
 * freshly server-rendered markup, so the "Case of {n}" label (and the
 * per-bag price) follow the selected variant. All value resolution stays
 * in Liquid — this only replaces the rendered fragment.
 */
class PackPricing extends HTMLElement {
  connectedCallback() {
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;
    section.addEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  disconnectedCallback() {
    const section = this.closest('.shopify-section, dialog');
    if (!section) return;
    section.removeEventListener(ThemeEvents.variantUpdate, this.#onVariantUpdate);
  }

  /**
   * @param {import('@theme/events').VariantUpdateEvent} event
   */
  #onVariantUpdate = (event) => {
    const { data } = event.detail;

    // Keep in sync with the product the update belongs to (handles combined listings).
    if (data.newProduct) {
      this.dataset.productId = data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const html = data.html;
    if (!html) return;

    const updated = html.querySelector(`pack-pricing[data-pack-show="${this.dataset.packShow}"]`);
    // If the fragment isn't in the response for any reason, leave the current
    // (server-rendered) markup untouched rather than clearing it.
    if (!updated) return;

    this.innerHTML = updated.innerHTML;
  };
}

if (!customElements.get('pack-pricing')) {
  customElements.define('pack-pricing', PackPricing);
}
